export const skipToMessage = "MRa";
export const readingPane = "NRa";
export default {skipToMessage,readingPane};